export default __webpack_public_path__ + "static/media/drag-icon.548e7dfe.svg";